<template>
  <router-view />
</template>

<script>

export default {
  name: 'PageView'
}
</script>
